import React from "react";
// import ProfileImg from "../images/profile.png"


function Home() {
    return (
        <div className="content">   
            <h1 className="big-title">Hi,<br />My name is Ivan</h1>
            <img className="profile-icon" src="/img/profile.png" />
            <h1 className="red big-title">Web Developer</h1>
        </div>
    );
}

export default Home;
